import { render, staticRenderFns } from "./ImportsDelinquents.vue?vue&type=template&id=e307e1fe"
import script from "./ImportsDelinquents.vue?vue&type=script&lang=js"
export * from "./ImportsDelinquents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports